import {
  MASTHEAD_LAYOUT,
  parseMastheadLayout,
  resolveMastheadLayout,
  type MastheadLayoutId,
} from '@/lib/category-masthead-layout'

const CAT_LAYOUT = (slug: string) => `haber:cat-layout:${slug}`
const CAT_MH = (slug: string) => `haber:cat-mh:${slug}`
const HOME_LAYOUT = 'haber:home-layout'

export function rememberCategoryMastheadLayout(
  slug: string,
  layout: MastheadLayoutId,
  showMasthead: boolean,
) {
  if (typeof window === 'undefined') return
  try {
    sessionStorage.setItem(CAT_LAYOUT(slug), String(layout))
    sessionStorage.setItem(CAT_MH(slug), showMasthead ? '1' : '0')
  } catch {
    /* ignore */
  }
}

export function peekCategoryMastheadLayout(slug: string): {
  layout: MastheadLayoutId
  showMasthead: boolean
} | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(CAT_LAYOUT(slug))
    if (raw == null) return null
    const mh = sessionStorage.getItem(CAT_MH(slug))
    return {
      layout: resolveMastheadLayout(Number(raw), 'category'),
      showMasthead: mh !== '0',
    }
  } catch {
    return null
  }
}

export function rememberHomeMastheadLayout(layout: MastheadLayoutId) {
  if (typeof window === 'undefined') return
  try {
    sessionStorage.setItem(HOME_LAYOUT, String(layout))
  } catch {
    /* ignore */
  }
}

export function peekHomeMastheadLayout(): MastheadLayoutId | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(HOME_LAYOUT)
    if (raw == null) return null
    return parseMastheadLayout(raw, MASTHEAD_LAYOUT.CENTER_SIDES)
  } catch {
    return null
  }
}
